<template>
  <section class=" bg-emerald-900 p-16 min-h-screen flex items-center justify-center">
    <div class="flex flex-col items-cente gap-4">
        <img src="@/assets/codi.png" alt="codi" class="w-96 mx-auto">
        <p class="text-2xl text-white font-semibold">
          Formulario de solicitud de eliminación de cuenta CodiKash Cliente.
        </p>
        <div class="flex flex-col">
          <p class="text-xl text-white font-semibold">1.- Escribe correo eléctronico asociado a la cuenta.</p>
          <p class="text-xl text-white font-semibold">2.- Enviar solicitud.</p>
        </div>
      
      <!-- Input: Designation [h-12] & min-w-[12rem] -->
      <form @submit.prevent="onSubmit" class="content-center space-x-4 pt-4 mx-auto">
        <input :disabled="flag" class="h-12 min-w-[12rem] rounded-lg border-emerald-500 indent-4 text-emerald-900 shadow-lg focus:outline-none focus:ring focus:ring-emerald-600" type="email" v-model="email" required placeholder="Correo eléctronico" />

        <button type="submit" :disabled="flag" class="h-12 min-w-[8rem] rounded-lg border-2 border-emerald-600 bg-emerald-500 text-emerald-50 shadow-lg hover:bg-emerald-600 focus:outline-none focus:ring focus:ring-emerald-600">Enviar</button>
      </form>

        <p class="text-2xl text-white font-semibold">
          Informacion que se elimina de manera permanente. 
        </p>
        <div class="flex flex-col">
          <p class="text-xl text-white font-semibold">- Información de usuario</p>
          <p class="text-xl text-white font-semibold">- Informació de compras</p>
          <p class="text-xl text-white font-semibold">- Informació de saldos</p>
        </div>
        <p class="text-2xl text-white font-semibold">
          Esta solicitud puede tardar de 1 a 2 días hábiles en ser aplicada.
        </p>
    </div>
      <!-- Button: Submit [h-12] -->
  </section>
</template>

<script>
import connection from '@/api/connection'

export default {
  data() {
    return {
      email: 'a@a.com',
      flag: false,
      message: '¡Solicitud enviada!'
    }
  },
  methods: {
    async onSubmit() {
      this.flag = true
      await connection.post(
                  `/users/deleteAccount`, 
                  { email: this.email }
                )
                .then(() => {
                  alert(this.message)
      this.flag = false

                }).catch(err => {
                  console.log('error', err);
      this.flag = false

                  alert(err)
                });
    }
  }
  
}
</script>
